const n = JSON.parse('"import_meta_env_placeholder"'), o = (t) => new Proxy(t, {
  get(e, r) {
    try {
      return n[r] || e[r];
    } catch {
      return "";
    }
  }
});
export {
  o as initEnv
};
